import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Fade from '@material-ui/core/Fade';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';

import ClearIcon from '@material-ui/icons/Clear';
import RefreshIcon from '@material-ui/icons/Refresh';

import { COLUMN_DISPLAY } from '../ProductsTable/constants';
import { resetAllFilters } from '../../redux/slices/filtersSlice';
import { useStyles } from './styles';
import Paper from '../Paper';
// import Button from '../Button';
import Accordion from '../Accordion';
import Filter from '../Filter';
import ProductsStatus from '../Filter/ProductsStatus';
import { resetChartFiltrationParameters } from '../../redux/slices/chartFilterSlice';
import useFilterUrl from '../../hooks/useFilterUrl';
import { COLORS } from '../../styles/constants';
import { getCurrentLanguage } from '../../utils/i18n';
import i18next from 'i18next';

const FiltersPanel = ({ categoryId, filtersOpen, handleFiltersOpen }) => {
	const { t } = useTranslation();
	const classes = useStyles();
	const filters = useSelector(state => state.categoryData.filters);
	const appliedState = useSelector(state => state.filters.appliedState);
	const filtersState = useSelector(state => state.filters.appliedState);
	const chartFiltrationParameters = useSelector(state => state.chartFilters.filtrationParameters);
	const [timeout, setTimeout] = useState(0);
	const dispatch = useDispatch();
	const appliedStateOfQuickFilter = useSelector(state => state.filters.appliedState);
	const supplyTypeState = appliedStateOfQuickFilter?.pwcv?.value?.toString()?.substring(0, 2);
	const { resetURL } = useFilterUrl();
	const lang = getCurrentLanguage();

	/* To prevent initial transition after page loads */
	useEffect(() => {
		setTimeout({ enter: 350, exit: 250 });
	}, []);

	const resetFilters = () => {
		dispatch(resetAllFilters());
		dispatch(resetChartFiltrationParameters());
		resetURL();
	};

	const getLabelForFilter = filter => {
		if (lang === 'cn' && i18next.exists(`filters.${filter.cid}`)) {
			return t(`filters.${filter.cid}`);
		}

		return filter.label;
	};

	return (
		<Fade in={filtersOpen} mountOnEnter timeout={timeout}>
			<div>
				<Grid xs container justifyContent="space-between" alignItems="center" className={classes.header}>
					<Grid item>
						<Typography variant="subtitle1" display="inline">
							{t('components.filtersPanel.title')}
						</Typography>
					</Grid>

					<Grid item>
						<Tooltip title={t('components.filtersPanel.buttons.reset')} aria-label="reset">
							<IconButton
								color="inherit"
								onClick={resetFilters}
								disabled={
									!Object.keys(filtersState).some(cid => filtersState[cid].used === true) &&
									!chartFiltrationParameters.value
								}>
								<RefreshIcon />
							</IconButton>
						</Tooltip>

						{false && (
							<Tooltip title={t('components.filtersPanel.buttons.hide')} aria-label="close">
								<IconButton color="inherit" onClick={() => handleFiltersOpen(false)}>
									<ClearIcon />
								</IconButton>
							</Tooltip>
						)}
					</Grid>
				</Grid>

				<Paper className={classes.paper}>
					{filters
						.filter(f => f.display !== COLUMN_DISPLAY.EXCLUDED)
						.map((filter, index) => (
							<Accordion
								key={filter.cid + index + '_accordion'}
								id={'FiltersPanel_Accordion__' + filter.cid}
								label={
									filter.cid === 'vim' && supplyTypeState === 'DC'
										? 'V<sub>IN<sub>DC</sub> (max)</sub> (V)'
										: filter.cid === 'vim' && supplyTypeState === 'AC'
										? 'V<sub>IN<sub>RMS</sub> (max)</sub> (V)'
										: filter.cid === 'vin' && supplyTypeState === 'DC'
										? 'V<sub>IN<sub>DC</sub> (min)</sub> (V)'
										: filter.cid === 'vin' && supplyTypeState === 'AC'
										? 'V<sub>IN<sub>RMS</sub> (min)</sub> (V)'
										: getLabelForFilter(filter)
								}
								style={{
									border: appliedState[filter.cid]?.used
										? `2px solid ${COLORS.PRIMARY}`
										: `1px solid ${COLORS.BORDER_TABLE_ROW}`
								}}
								cid={filter.cid}
								defaultExpanded={index < 2}>
								<Grid container direction="column" spacing={1}>
									<Grid item container>
										<Filter
											hiddenlabel
											categoryId={categoryId}
											label={filter.label}
											appliedLogic={filtersState[filter.cid].logic}
											appliedValue={filtersState[filter.cid].value}
											disabled={filtersState[filter.cid].disabled}
											cid={filter.cid}
											conditional={filter.conditional}
											constraints={filter.constraints || null}
											logic={filter.logic}
											values={filter.values}
											dataType={filter.type || null}
											multiSelect={filter.multiSelect || null}
											order={filter.order || null}
											unit={filter.unit || null}
										/>
									</Grid>

									<Grid item>
										<ProductsStatus />
									</Grid>
								</Grid>
							</Accordion>
						))}
				</Paper>
			</div>
		</Fade>
	);
};

FiltersPanel.propTypes = {
	categoryId: PropTypes.string.isRequired,
	filtersOpen: PropTypes.bool.isRequired
};

export default React.memo(FiltersPanel);
